import * as React from 'react';
import { TooltipDesktop } from '@cian/ui-kit/tooltip';
import { Label } from './Label';
import * as styles from './BuilderStatus.css';

export interface IBuilderStatusProps {
  labelText: string;
  tooltipTitle: string;
  tooltipText: string;
}

export function BuilderStatus(props: IBuilderStatusProps) {
  const { labelText, tooltipText, tooltipTitle } = props;

  return (
    <div className={styles['container']}>
      <TooltipDesktop
        title={
          <div className={styles['tooltip-container']}>
            <div className={styles['title']}>{tooltipTitle}</div>
            <div className={styles['text']}>{tooltipText}</div>
          </div>
        }
        theme="white"
      >
        <Label labelText={labelText} />
      </TooltipDesktop>
    </div>
  );
}
